import { FormTemplateFull } from '../models/formTemplate'

export interface FormTemplateActionsProps{
    formTemplate: FormTemplateFull
}

function FormTemplateActions(props: FormTemplateActionsProps) {
  return (
    <div>FormTemplateActions</div>
  )
}

export default FormTemplateActions
